export default [
  /**
   * 选择手机号是否在用
   */
  {
    path: '/change-mobile',
    meta: {
      title: '变更手机号',
      background: '#F2F5FF',
    },
    component: () => import('@/views/change-mobile/index.vue'),
  },
  /**
   * 确认变更手机号信息
   */
  {
    path: '/change-mobile/blockup-verify',
    meta: {
      title: '变更手机号',
      background: '#fff',
    },
    component: () => import('@/views/change-mobile/blockup-verify.vue'),
  },
  /**
   * 停用手机号-确认变更信息
   */
  {
    path: '/change-mobile/verify',
    meta: {
      title: '变更手机号',
      background: '#fff',
    },
    component: () => import('@/views/change-mobile/verify.vue'),
  },
  /**
   * 新手机号发送短信验证码
   */
  {
    path: '/change-mobile/confirm',
    meta: {
      title: '变更手机号',
      background: '#fff',
    },
    component: () => import('@/views/change-mobile/confirm.vue'),
  },
  /**
   * 选择验证手机号方式
   */
  {
    path: '/amend-mobile',
    meta: {
      title: '身份验证',
      background: '#F2F5FF',
      customNavBar: true,
    },
    component: () => import('@/views/amend-mobile/index.vue'),
  },

  /**
   * 新手机号验证
   */
  {
    path: '/amend-mobile/phone-verify',
    meta: {
      title: '新手机号验证',
      background: '#F5F6FA',
      customNavBar: true,
      excludeLogin: true,
      excludeSyncUserInfo: true,
    },
    component: () => import('@/views/amend-mobile/phone-verify.vue'),
  },
  /**
   * 原手机号验证码页面
   */
  {
    path: '/amend-mobile/original-phone-captcha',
    meta: {
      title: '原手机号验证',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/amend-mobile/original-phone-captcha.vue'),
  },
  /**
   * 新手机号验证码页面
   */
  {
    path: '/amend-mobile/new-phone-captcha',
    meta: {
      title: '新手机号验证',
      background: '#fff',
      customNavBar: true,
      excludeLogin: true,
      excludeSyncUserInfo: true,
    },
    component: () => import('@/views/amend-mobile/new-phone-captcha.vue'),
  },
  /**
   * 原账号信息
   */
  {
    path: '/amend-mobile/original-info',
    meta: {
      title: '原账号信息',
      background: '#F5F6FA',
      customNavBar: true,
      excludeLogin: true,
    },
    component: () => import('@/views/amend-mobile/original-info.vue'),
  },
];
